var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Dialog as MuiDialog, makeStyles } from "@material-ui/core";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { initialDialog } from "../types";
import { RefDialogContext } from "./Provider";
const useStyles = makeStyles((theme) => ({
    paper: ({ background, color, minHeight, maxHeight, maxWidth, py, px }) => ({
        background: theme.palette.background[background],
        color: theme.palette.text[color],
        minHeight: window.innerHeight,
        width: "100%",
        paddingTop: theme.spacing(py),
        paddingBottom: theme.spacing(py),
        paddingRight: theme.spacing(px),
        paddingLeft: theme.spacing(px),
        margin: 0,
        textAlign: "center",
        [theme.breakpoints.up("sm")]: {
            maxWidth,
            minHeight,
            maxHeight,
            margin: theme.spacing(1)
        },
        [theme.breakpoints.down("sm")]: {
            maxHeight: 'none !important',
        }
    }),
    scrollPaper: {
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            maxHeight: 'none !important',
        }
    }
}));
const RefDialog = forwardRef((_a, ref) => {
    var { background = "default", color = "primary", maxWidth = 360, minHeight, maxHeight, py = 1, px = 1, unregister, onClose } = _a, props = __rest(_a, ["background", "color", "maxWidth", "minHeight", "maxHeight", "py", "px", "unregister", "onClose"]);
    const classes = useStyles({
        background,
        color,
        maxWidth,
        minHeight,
        maxHeight,
        py,
        px
    });
    const [dialog, setDialog] = useState(initialDialog);
    const cleanup = () => {
        setDialog(initialDialog);
        if (onClose instanceof Function) {
            onClose();
        }
    };
    useImperativeHandle(ref, () => ({
        close: () => cleanup(),
        open: (component) => setDialog({
            open: !dialog.open,
            component
        })
    }));
    useEffect(() => {
        return () => {
            unregister();
        };
    }, []);
    return (React.createElement(MuiDialog, Object.assign({ open: dialog.open, onClose: cleanup, classes: {
            paper: classes.paper,
            scrollPaper: classes.scrollPaper
        } }, props), dialog.component &&
        React.cloneElement(dialog.component, Object.assign(Object.assign({}, dialog.component.props), { close: cleanup }))));
});
RefDialog.displayName = "RefDialog";
export const Dialog = (_a) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    return (React.createElement(RefDialogContext.Consumer, null, ({ register, unregister }) => (React.createElement(RefDialog, Object.assign({ ref: (ref) => register(name, ref), unregister: () => unregister(name) }, props)))));
};
//# sourceMappingURL=Dialog.js.map